import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Divder from '../../Components/CommonComp/Divder';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import CustomTabs from '../../Components/CommonComp/CustomTabs/CustomTabs';
import CmsTabBody from '../../Components/Cms/CmsTabBody';
import { CmsData } from '../../data/cmsData';
import CustomTabExpand from '../../Components/CommonComp/CustomTabs/CustomTabExpand';


function Cms({handleNavParams}) {
  const [tabValue, setTabValue] = useState(1);

  const handleTabs = (data) => {
    setTabValue(data.id);
    handleNavParams({
      navTitle: data.label,
    });
  };

  return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
          // bgcolor: theme.backgroundColor.box.main,
          // p: 4,
          // pl: 0,
        };
      }}
    >
      <CustomBox padding={0}>
        {/* <CustomTabs tabList={CmsData.tabs} tabClick={handleTabs} /> */}
        <CustomTabExpand tabList={CmsData.tabs} tabClick={handleTabs} />
      </CustomBox>
      <Divder spacing={1} />
      <CmsTabBody activeTab={tabValue} />
      {/* <CustomTabExpand */}
      <Divder spacing={1.2} />
    </Box>
  );
}

export default Cms;
